var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12932_43613)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.586 2.6C10.94 2.24648 11.4136 2.03846 11.9134 2.01698C12.4132 1.99551 12.903 2.16214 13.286 2.484L13.414 2.601L15.314 4.5H18C18.5044 4.50009 18.9901 4.69077 19.3599 5.03384C19.7297 5.3769 19.9561 5.84702 19.994 6.35L20 6.5V9.186L21.9 11.086C22.2538 11.44 22.462 11.9139 22.4834 12.4139C22.5049 12.914 22.3381 13.4039 22.016 13.787L21.899 13.914L19.999 15.814V18.5C19.9991 19.0046 19.8086 19.4906 19.4655 19.8605C19.1224 20.2305 18.6521 20.4572 18.149 20.495L18 20.5H15.315L13.415 22.4C13.0609 22.7538 12.5871 22.962 12.087 22.9835C11.587 23.005 11.097 22.8382 10.714 22.516L10.587 22.4L8.68697 20.5H5.99997C5.49539 20.5002 5.0094 20.3096 4.63942 19.9665C4.26944 19.6234 4.04281 19.1532 4.00497 18.65L3.99997 18.5V15.814L2.09997 13.914C1.74616 13.56 1.53797 13.0861 1.51649 12.5861C1.49502 12.086 1.66182 11.5961 1.98397 11.213L2.09997 11.086L3.99997 9.186V6.5C4.00006 5.9956 4.19074 5.50986 4.53381 5.14009C4.87687 4.77032 5.34699 4.54383 5.84997 4.506L5.99997 4.5H8.68597L10.586 2.6ZM15.079 9.483L10.835 13.727L9.06697 11.959C8.87933 11.7715 8.62489 11.6662 8.35962 11.6663C8.09435 11.6664 7.83998 11.7719 7.65247 11.9595C7.46496 12.1471 7.35967 12.4016 7.35977 12.6669C7.35986 12.9321 7.46533 13.1865 7.65297 13.374L10.057 15.778C10.1591 15.8802 10.2804 15.9613 10.4139 16.0166C10.5474 16.0719 10.6905 16.1004 10.835 16.1004C10.9795 16.1004 11.1226 16.0719 11.256 16.0166C11.3895 15.9613 11.5108 15.8802 11.613 15.778L16.493 10.897C16.6751 10.7084 16.7759 10.4558 16.7736 10.1936C16.7714 9.9314 16.6662 9.68059 16.4808 9.49518C16.2954 9.30977 16.0446 9.20461 15.7824 9.20233C15.5202 9.20005 15.2676 9.30084 15.079 9.483Z",
    fill: "#5474C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12932_43613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.ca08f9de57fa9690fbf4b92145f3d9a9.svg";
export { ForwardRef as ReactComponent };